/** Options for the workforce counting method select input. */
export const workforceCountingMethodOptions: Array<{ code: string; name: string }> = [
  { code: "fte", name: "Gjennomsnittlig årsverk (FTE)" },
  { code: "hc-avg", name: "Gjennomsnittlig antall ansatte" },
  { code: "hc-eop", name: "Antall ansatte ved periodeslutt" },
]

/** Code → display-label lookup for use in the label resolver registry. */
export const workforceCountingMethodsNb: Record<string, string> = Object.fromEntries(
  workforceCountingMethodOptions.map((o) => [o.code, o.name]),
)
